import { ApolloClient } from '@apollo/client';

import { finleyBuffer } from '@finley-technologies/common';
import { FinleyBuffer, Pdf } from '@finley-technologies/finley-types';
import { PDFExtractor } from '@finley-technologies/tape-sanitizer';

import {
  GetPdfAnalysisQueryGQLType,
  GetPdfAnalysisQueryVariablesGQLType,
  GetPdfAnalysisDocumentGQLType,
} from 'packages/tapeBuilder/requests/tapeBuilder.gql.generated';

export const getPdfExtractor = (
  apolloClient: ApolloClient<object>,
): PDFExtractor => {
  return async (buffer: FinleyBuffer, questions: Pdf.QueryQuestion[]) => {
    const bufferString = finleyBuffer.toBase64(buffer);
    const { data } = await apolloClient.query<
      GetPdfAnalysisQueryGQLType,
      GetPdfAnalysisQueryVariablesGQLType
    >({
      query: GetPdfAnalysisDocumentGQLType,
      variables: {
        input: {
          buffer: bufferString,
          questions,
        },
      },
    });
    const { rawResponse, answers: gqlAnswers } = data.pdfAnalysis;

    const answers: Pdf.QueryAnswer[] = gqlAnswers.map(
      ({ value, error, confidence, pageNumber }) => {
        return {
          value: value || null,
          error: error || null,
          confidence,
          pageNumber,
        };
      },
    );
    return {
      rawdata: rawResponse,
      answers,
    };
  };
};
